const component = "site-sections-tree-section-category-filter";

export const siteSectionsTreeSectionCategoryFilter = {
  component,
  trigger: `${component}/filters/section-category/trigger`,
  triggerLabel: `${component}/filters/section-category/trigger-label`,
  popover: `${component}/filters/section-category/popover`,
  searchInput: `${component}/filters/section-category/search-input`,
  option: (category: number | string): string => `${component}/filters/section-category/options/${category}`,
  checkbox: (category: number | string): string => `${component}/filters/section-category/options/${category}/checkbox`,
  createButton: `${component}/filters/section-category/create-button`,
  clearButton: `${component}/filters/section-category/clear-button`,
  creationInput: `${component}/filters/section-category/creation-input`,
  confirmButton: `${component}/filters/section-category/confirm-button`,
  cancelButton: `${component}/filters/section-category/cancel-button`,
};
